import { useEffect, useRef, FC } from 'react'
import { Picker } from 'emoji-mart'

import styles from './emojiPicker.module.scss'

type emoji = {
  id: string
  native: string
}

const EmojiPicker: FC<{ onEmojiSelect: (emoji: emoji) => void }> = props => {
  const ref = useRef(null)

  useEffect(() => {
    new Picker({
      data: async () => {
        const response = await fetch('https://cdn.jsdelivr.net/npm/@emoji-mart/data')

        return response.json()
      },
      theme: 'light',
      ref,
      ...props
    })
  }, [props])

  return <div ref={ref} className={styles.picker} />
}

export { EmojiPicker }
